import http from '@/api/http'

export default {
    getRegistryList(cb, form) {
        http.post('/api/carbon/registry/list', cb, form)
    },
    getCountry(cb, request) {
        http.get('/api/carbon/registry/country', cb, request)
    },
    getProjectType(cb, request) {
        http.get('/api/carbon/registry/project/type', cb, request)
    },
    getMethodology(cb, request) {
        http.get('/api/carbon/registry/methodology', cb, request)
    },
    getProject(cb, form) {
        http.post('/api/carbon/registry/project', cb, form)
    },
    getOauthLogin(cb, form) {
        http.post('/api/oauthLogin', cb, form)
    },
    getRegistryState(cb, request) {
        http.get('/api/carbon/registry/state', cb, request)
    },
    getLatDetail(cb, request) {
        http.get('/api/carbon/registry/coordinate', cb, request)
    },
    getprojectId(cb, request) {
        http.get('/api/carbon/registry/projectId', cb, request)
    },
    changeSubmit(cb, form) {
        http.post('/api/carbon/complianceTokenizedCredits/save', cb, form)
    },
    submitProjectInfo(cb, form) {
        http.post('/api/projectInfo/nftHashAndProjectSiteId', cb, form)
    },
    submitNfdtLedgerList(cb, form) {
        http.post('/api/nfdtLedger/list', cb, form)
    },
    nfdtDetail(cb, form) {
        http.get('/api/nfdtLedger', cb, form)
    },
    getIssueCarbon(cb, request) {
        http.get('/api/projectInfo/issuance', cb, request)
    },
    confirmIssue(cb, form) {
        http.post('/api/projectInfo/issuance/add', cb, form)
    },
    projectInfoHome(cb, form) {
        http.get('/api/projectInfo/home', cb, form)
    },
    getcarbonTotal(cb, form) {
        http.get('/api/carbon/approvalPending', cb, form)
    },
    changeProjectInfo(cb, form) {
        http.post('/api/projectInfo/transaction', cb, form)
    },



}